import { CloseButton } from './CloseButton';
import { Tabs } from './Tabs';

interface HeaderProps {
  onClose: () => void;
}

export const Header = ({ onClose }: HeaderProps) => {
  return (
    <div className="relative flex h-14 shrink-0 items-end justify-between gap-6 self-stretch px-4">
      <Tabs />
      <CloseButton onClose={onClose} />
    </div>
  );
};
